import { useCallback } from 'react';

interface ModalInputsDocumentInfoProps {
    documentFormInfo: {
        documentId: string;
        documentDate: string;
    };
    onChangeInput: (documentInfoName: string, documentInfoValue: string) => void;
}

export const useModalInputsDocumentInfo = ({
    documentFormInfo,
    onChangeInput,
}: ModalInputsDocumentInfoProps) => {
    const onDate = useCallback(
        (value: string) => {
            onChangeInput('documentDate', value);
        },
        [documentFormInfo]
    );
    return { onDate };
};
